enum LedState {
  Off = 'off',
  PrimaryColor = 'primary',
  SuccessColor = 'success',
  ErrorColor = 'error',
}

export default LedState;
